import { ca } from '@cian/analytics';

export const trackCreteCpdDraftClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'Click',
    label: 'cpdCardDealObject',
    page: {
      pageType: 'OfferScreen',
      extra: {
        cpdDealType: 'sale',
        source: 'cpdCardDealObject',
      },
    },
    useLastProducts: true,
  });
};

export const trackModalOpen = (source: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'Show_sopr',
    label: 'cpdDescription',
    page: {
      pageType: 'OfferScreen',
      extra: {
        source,
      },
    },
    useLastProducts: true,
  });
};
